module.exports = __webpack_public_path__ + "static/media/Ash.8b709474.jpg";